// ========================================
// ================== V3 ==================
// ========================================

import * as aTypes from "./actionTypes";

// ============ MY USERS  ============
export const initFetchCode = () => {
  return {
    type: aTypes.V3_CODE_INIT,
  };
};

export const fetchCodeSuccess = (code) => {
  return {
    type: aTypes.V3_CODE_SET,
    code: code,
  };
};

export const fetchCodeFail = (error) => {
  return {
    type: aTypes.V3_CODE_FETCH_FAIL,
    error: error,
  };
};
